var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./EDI-AFR.svg": "./src/icons/svg/EDI-AFR.svg",
	"./EDI-AMS.svg": "./src/icons/svg/EDI-AMS.svg",
	"./EDI-BILL.svg": "./src/icons/svg/EDI-BILL.svg",
	"./EDI-BOOKING.svg": "./src/icons/svg/EDI-BOOKING.svg",
	"./EDI-PREMANIFEST.svg": "./src/icons/svg/EDI-PREMANIFEST.svg",
	"./EDI-VGM.svg": "./src/icons/svg/EDI-VGM.svg",
	"./TEU.svg": "./src/icons/svg/TEU.svg",
	"./airExport.svg": "./src/icons/svg/airExport.svg",
	"./airImport.svg": "./src/icons/svg/airImport.svg",
	"./approvalMatters.svg": "./src/icons/svg/approvalMatters.svg",
	"./baoguanhang.svg": "./src/icons/svg/baoguanhang.svg",
	"./baoxiangongsi.svg": "./src/icons/svg/baoxiangongsi.svg",
	"./baseData.svg": "./src/icons/svg/baseData.svg",
	"./bi.svg": "./src/icons/svg/bi.svg",
	"./biWhite.svg": "./src/icons/svg/biWhite.svg",
	"./bochuangongsi.svg": "./src/icons/svg/bochuangongsi.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./cangku.svg": "./src/icons/svg/cangku.svg",
	"./cargoware-logo-login.svg": "./src/icons/svg/cargoware-logo-login.svg",
	"./cargoware-logo.svg": "./src/icons/svg/cargoware-logo.svg",
	"./changzhan.svg": "./src/icons/svg/changzhan.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./chaxun-peizhi.svg": "./src/icons/svg/chaxun-peizhi.svg",
	"./chaxun-qingchu.svg": "./src/icons/svg/chaxun-qingchu.svg",
	"./chaxun-shousuo.svg": "./src/icons/svg/chaxun-shousuo.svg",
	"./checkbox-checked-edit.svg": "./src/icons/svg/checkbox-checked-edit.svg",
	"./checkbox-checked-notEdit.svg": "./src/icons/svg/checkbox-checked-notEdit.svg",
	"./checkbox-checked.svg": "./src/icons/svg/checkbox-checked.svg",
	"./checkbox-checked_bak.svg": "./src/icons/svg/checkbox-checked_bak.svg",
	"./checkbox-notChecked-edit.svg": "./src/icons/svg/checkbox-notChecked-edit.svg",
	"./checkbox-notChecked-notEdit.svg": "./src/icons/svg/checkbox-notChecked-notEdit.svg",
	"./checkbox-notChecked.svg": "./src/icons/svg/checkbox-notChecked.svg",
	"./checkbox-notChecked_bak.svg": "./src/icons/svg/checkbox-notChecked_bak.svg",
	"./chedui.svg": "./src/icons/svg/chedui.svg",
	"./chuangongsi.svg": "./src/icons/svg/chuangongsi.svg",
	"./chuanwudaili.svg": "./src/icons/svg/chuanwudaili.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./company.svg": "./src/icons/svg/company.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./daohang-caiwujiesuan.svg": "./src/icons/svg/daohang-caiwujiesuan.svg",
	"./daohang-ediguanli.svg": "./src/icons/svg/daohang-ediguanli.svg",
	"./daohang-haiyunchukou.svg": "./src/icons/svg/daohang-haiyunchukou.svg",
	"./daohang-jiqiren.svg": "./src/icons/svg/daohang-jiqiren.svg",
	"./daohang-shenpiguanli.svg": "./src/icons/svg/daohang-shenpiguanli.svg",
	"./daohang-tongjifenxi.svg": "./src/icons/svg/daohang-tongjifenxi.svg",
	"./daohang-xinxiguanli.svg": "./src/icons/svg/daohang-xinxiguanli.svg",
	"./daohang-xitongguanli.svg": "./src/icons/svg/daohang-xitongguanli.svg",
	"./daohang-zaixianfuwu.svg": "./src/icons/svg/daohang-zaixianfuwu.svg",
	"./daohang-zhinengyinqin.svg": "./src/icons/svg/daohang-zhinengyinqin.svg",
	"./daohang-ziliaoguanli.svg": "./src/icons/svg/daohang-ziliaoguanli.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./dept.svg": "./src/icons/svg/dept.svg",
	"./dianzidingcangrizhi.svg": "./src/icons/svg/dianzidingcangrizhi.svg",
	"./dingcangdaili.svg": "./src/icons/svg/dingcangdaili.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./done.svg": "./src/icons/svg/done.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./elevator.svg": "./src/icons/svg/elevator.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./fahuodanwei.svg": "./src/icons/svg/fahuodanwei.svg",
	"./fankongcangdanrizhi.svg": "./src/icons/svg/fankongcangdanrizhi.svg",
	"./fast-forward.svg": "./src/icons/svg/fast-forward.svg",
	"./fba.svg": "./src/icons/svg/fba.svg",
	"./fcllcl-B.svg": "./src/icons/svg/fcllcl-B.svg",
	"./fcllcl-C.svg": "./src/icons/svg/fcllcl-C.svg",
	"./fcllcl-F.svg": "./src/icons/svg/fcllcl-F.svg",
	"./fcllcl-L.svg": "./src/icons/svg/fcllcl-L.svg",
	"./fcllcl-M.svg": "./src/icons/svg/fcllcl-M.svg",
	"./fcllcl-P.svg": "./src/icons/svg/fcllcl-P.svg",
	"./fcllcl-S.svg": "./src/icons/svg/fcllcl-S.svg",
	"./fileStorage.svg": "./src/icons/svg/fileStorage.svg",
	"./finance.svg": "./src/icons/svg/finance.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./freightRate.svg": "./src/icons/svg/freightRate.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./gjzs.svg": "./src/icons/svg/gjzs.svg",
	"./gonggao.svg": "./src/icons/svg/gonggao.svg",
	"./grid-icon-disabled.svg": "./src/icons/svg/grid-icon-disabled.svg",
	"./grid-icon-enabled.svg": "./src/icons/svg/grid-icon-enabled.svg",
	"./group.svg": "./src/icons/svg/group.svg",
	"./guide 2.svg": "./src/icons/svg/guide 2.svg",
	"./guide-arrow-setting.svg": "./src/icons/svg/guide-arrow-setting.svg",
	"./guide-arrow.svg": "./src/icons/svg/guide-arrow.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./guoneidaili.svg": "./src/icons/svg/guoneidaili.svg",
	"./haiwaidaili.svg": "./src/icons/svg/haiwaidaili.svg",
	"./hangkonggongsi.svg": "./src/icons/svg/hangkonggongsi.svg",
	"./hangyeshuyu-caiwu.svg": "./src/icons/svg/hangyeshuyu-caiwu.svg",
	"./hangyeshuyu-haiyun.svg": "./src/icons/svg/hangyeshuyu-haiyun.svg",
	"./hangyeshuyu-kongyun.svg": "./src/icons/svg/hangyeshuyu-kongyun.svg",
	"./hangyeshuyu-qita.svg": "./src/icons/svg/hangyeshuyu-qita.svg",
	"./head_company.svg": "./src/icons/svg/head_company.svg",
	"./huilv-CNY.svg": "./src/icons/svg/huilv-CNY.svg",
	"./huilv-EUR.svg": "./src/icons/svg/huilv-EUR.svg",
	"./huilv-HKD.svg": "./src/icons/svg/huilv-HKD.svg",
	"./huilv-JPY.svg": "./src/icons/svg/huilv-JPY.svg",
	"./huilv-USD.svg": "./src/icons/svg/huilv-USD.svg",
	"./icoim_u1.svg": "./src/icons/svg/icoim_u1.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./info.svg": "./src/icons/svg/info.svg",
	"./information.svg": "./src/icons/svg/information.svg",
	"./insurance.svg": "./src/icons/svg/insurance.svg",
	"./integrated.svg": "./src/icons/svg/integrated.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./jiqiren.svg": "./src/icons/svg/jiqiren.svg",
	"./jobState0.svg": "./src/icons/svg/jobState0.svg",
	"./jobState1.svg": "./src/icons/svg/jobState1.svg",
	"./jobState2.svg": "./src/icons/svg/jobState2.svg",
	"./jobState3.svg": "./src/icons/svg/jobState3.svg",
	"./jobState4.svg": "./src/icons/svg/jobState4.svg",
	"./kuaidigongsi.svg": "./src/icons/svg/kuaidigongsi.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./liebiao-bc.svg": "./src/icons/svg/liebiao-bc.svg",
	"./liebiao-coload.svg": "./src/icons/svg/liebiao-coload.svg",
	"./liebiao-consol.svg": "./src/icons/svg/liebiao-consol.svg",
	"./liebiao-fcl.svg": "./src/icons/svg/liebiao-fcl.svg",
	"./liebiao-gantanhao1.svg": "./src/icons/svg/liebiao-gantanhao1.svg",
	"./liebiao-gantanhao2.svg": "./src/icons/svg/liebiao-gantanhao2.svg",
	"./liebiao-gantanhao3.svg": "./src/icons/svg/liebiao-gantanhao3.svg",
	"./liebiao-lcl.svg": "./src/icons/svg/liebiao-lcl.svg",
	"./liebiao-shenhe.svg": "./src/icons/svg/liebiao-shenhe.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./loading-bars.svg": "./src/icons/svg/loading-bars.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./master.svg": "./src/icons/svg/master.svg",
	"./menu/sales-def.svg": "./src/icons/svg/menu/sales-def.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./mini-program.svg": "./src/icons/svg/mini-program.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./pagination-next.svg": "./src/icons/svg/pagination-next.svg",
	"./pagination-prev.svg": "./src/icons/svg/pagination-prev.svg",
	"./partner.svg": "./src/icons/svg/partner.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./permission-child-level.svg": "./src/icons/svg/permission-child-level.svg",
	"./permission-data-more.svg": "./src/icons/svg/permission-data-more.svg",
	"./person-in-grid-cell.svg": "./src/icons/svg/person-in-grid-cell.svg",
	"./person-in-grid-cell_bak.svg": "./src/icons/svg/person-in-grid-cell_bak.svg",
	"./pinpiao-C.svg": "./src/icons/svg/pinpiao-C.svg",
	"./pinpiao-F.svg": "./src/icons/svg/pinpiao-F.svg",
	"./pinpiao-L.svg": "./src/icons/svg/pinpiao-L.svg",
	"./pinpiao-M.svg": "./src/icons/svg/pinpiao-M.svg",
	"./pinpiao-P.svg": "./src/icons/svg/pinpiao-P.svg",
	"./pinpiao-S.svg": "./src/icons/svg/pinpiao-S.svg",
	"./pinpiao-U.svg": "./src/icons/svg/pinpiao-U.svg",
	"./portal.svg": "./src/icons/svg/portal.svg",
	"./project.svg": "./src/icons/svg/project.svg",
	"./promotionManagement.svg": "./src/icons/svg/promotionManagement.svg",
	"./qita.svg": "./src/icons/svg/qita.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./quanju-zuzhi.svg": "./src/icons/svg/quanju-zuzhi.svg",
	"./question-white.svg": "./src/icons/svg/question-white.svg",
	"./question.svg": "./src/icons/svg/question.svg",
	"./railExport.svg": "./src/icons/svg/railExport.svg",
	"./report-template-category-icon.svg": "./src/icons/svg/report-template-category-icon.svg",
	"./report-template-icon.svg": "./src/icons/svg/report-template-icon.svg",
	"./report.svg": "./src/icons/svg/report.svg",
	"./right.svg": "./src/icons/svg/right.svg",
	"./rookie.svg": "./src/icons/svg/rookie.svg",
	"./rsjx.svg": "./src/icons/svg/rsjx.svg",
	"./sales.svg": "./src/icons/svg/sales.svg",
	"./se-basic-customerLevel.svg": "./src/icons/svg/se-basic-customerLevel.svg",
	"./se-basic-periodEnd.svg": "./src/icons/svg/se-basic-periodEnd.svg",
	"./se-basic-signDesc.svg": "./src/icons/svg/se-basic-signDesc.svg",
	"./se-basic-signDesc_bak.svg": "./src/icons/svg/se-basic-signDesc_bak.svg",
	"./seaExport.svg": "./src/icons/svg/seaExport.svg",
	"./seaImport.svg": "./src/icons/svg/seaImport.svg",
	"./search-plus.svg": "./src/icons/svg/search-plus.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./settlement.svg": "./src/icons/svg/settlement.svg",
	"./shenhe-fangdanfanghuo.svg": "./src/icons/svg/shenhe-fangdanfanghuo.svg",
	"./shenhe-shihougenggai.svg": "./src/icons/svg/shenhe-shihougenggai.svg",
	"./shenhe-shoufushenqing.svg": "./src/icons/svg/shenhe-shoufushenqing.svg",
	"./shenhe-teshufeiyong.svg": "./src/icons/svg/shenhe-teshufeiyong.svg",
	"./shenhe-zuoyewancheng.svg": "./src/icons/svg/shenhe-zuoyewancheng.svg",
	"./ship-in-grid-cell.svg": "./src/icons/svg/ship-in-grid-cell.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./slave.svg": "./src/icons/svg/slave.svg",
	"./sop-air.svg": "./src/icons/svg/sop-air.svg",
	"./sop-land.svg": "./src/icons/svg/sop-land.svg",
	"./sop-sea.svg": "./src/icons/svg/sop-sea.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./statistical.svg": "./src/icons/svg/statistical.svg",
	"./suoyou.svg": "./src/icons/svg/suoyou.svg",
	"./systemMaintenance.svg": "./src/icons/svg/systemMaintenance.svg",
	"./systemMonitoring.svg": "./src/icons/svg/systemMonitoring.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./term-caiwujiesuan.svg": "./src/icons/svg/term-caiwujiesuan.svg",
	"./term-haiyunchukou.svg": "./src/icons/svg/term-haiyunchukou.svg",
	"./term-haiyunjinkou.svg": "./src/icons/svg/term-haiyunjinkou.svg",
	"./term-kongyunchukou.svg": "./src/icons/svg/term-kongyunchukou.svg",
	"./term-kongyunjinkou.svg": "./src/icons/svg/term-kongyunjinkou.svg",
	"./term-zongheyewu.svg": "./src/icons/svg/term-zongheyewu.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tidanquerenrizhi.svg": "./src/icons/svg/tidanquerenrizhi.svg",
	"./tonghangkehu.svg": "./src/icons/svg/tonghangkehu.svg",
	"./tongyongbaobiao-caiwu.svg": "./src/icons/svg/tongyongbaobiao-caiwu.svg",
	"./tongyongbaobiao-caozuo.svg": "./src/icons/svg/tongyongbaobiao-caozuo.svg",
	"./tongyongbaobiao-child.svg": "./src/icons/svg/tongyongbaobiao-child.svg",
	"./tongyongbaobiao-guanli.svg": "./src/icons/svg/tongyongbaobiao-guanli.svg",
	"./tongyongbaobiao-menu.svg": "./src/icons/svg/tongyongbaobiao-menu.svg",
	"./tongyongbaobiao-xiaoshou.svg": "./src/icons/svg/tongyongbaobiao-xiaoshou.svg",
	"./tongzhigonggao.svg": "./src/icons/svg/tongzhigonggao.svg",
	"./top_index.svg": "./src/icons/svg/top_index.svg",
	"./top_menu.svg": "./src/icons/svg/top_menu.svg",
	"./top_message.svg": "./src/icons/svg/top_message.svg",
	"./top_question.svg": "./src/icons/svg/top_question.svg",
	"./top_service.svg": "./src/icons/svg/top_service.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./undone.svg": "./src/icons/svg/undone.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./wrong.svg": "./src/icons/svg/wrong.svg",
	"./xiaoxi.svg": "./src/icons/svg/xiaoxi.svg",
	"./xiaoxidaiban.svg": "./src/icons/svg/xiaoxidaiban.svg",
	"./yibiao-bohui.svg": "./src/icons/svg/yibiao-bohui.svg",
	"./yibiao-chachuolv.svg": "./src/icons/svg/yibiao-chachuolv.svg",
	"./yibiao-jieguan.svg": "./src/icons/svg/yibiao-jieguan.svg",
	"./yibiao-jinjikaipiao.svg": "./src/icons/svg/yibiao-jinjikaipiao.svg",
	"./yibiao-jishilv.svg": "./src/icons/svg/yibiao-jishilv.svg",
	"./yibiao-kaichuan.svg": "./src/icons/svg/yibiao-kaichuan.svg",
	"./yibiao-tijiao.svg": "./src/icons/svg/yibiao-tijiao.svg",
	"./yibiao-yijiao.svg": "./src/icons/svg/yibiao-yijiao.svg",
	"./yibiao-yujing.svg": "./src/icons/svg/yibiao-yujing.svg",
	"./yibiao-yuqidaiban.svg": "./src/icons/svg/yibiao-yuqidaiban.svg",
	"./yibiao-zhengchangkaipiao.svg": "./src/icons/svg/yibiao-zhengchangkaipiao.svg",
	"./yujingtixing.svg": "./src/icons/svg/yujingtixing.svg",
	"./yupeicangdanrizhi.svg": "./src/icons/svg/yupeicangdanrizhi.svg",
	"./zengzhifuwu.svg": "./src/icons/svg/zengzhifuwu.svg",
	"./zhidinghuodaili.svg": "./src/icons/svg/zhidinghuodaili.svg",
	"./zhijiekehu.svg": "./src/icons/svg/zhijiekehu.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync recursive \\.svg$";